import React, { useDebugValue, useEffect, useState } from "react";
import "./ReportComponents.css";
import MissionModelingService from "../../MissionModelingService";
import moment from "moment";
import { useParams } from "react-router-dom";

const GroundStationAccessReport = (props) => {
  const params = useParams()
  const {
    mission_name,
    mission_id
  } = params;

  const [groundStationItems, setGroundStationItems] = useState({
    Analysis_Inputs: true,
    Output: true,
  });
  const [groundStationOutputs,setGroundStationOutputs]=useState<Array<{ label: string, value: number | undefined }>>([])
  const groundStationValues = [
    "Ground Station 01",
    "Ground Station 02",
    "Ground Station 03",
    "Ground Station 04",
  ];
  useEffect(() => {
    MissionModelingService.getGroundStationAccessAnalyis(mission_id)
      .then((res) => {
        if (res?.data) {
          console.log("---->",res?.data);
          // setPlanes(res?.data?.reports[0]?.planeName)
          const NewgroundStationOutputs = [
            { label: "Access Time", value: res?.data[0]?.overview?.['accesstime'] },
            { label: "Azimuth-Elevation-Range", value: res?.data[0]?.overview?.['az-el-range']},
            { label: "Max Elevation of the access", value: res?.data[0]?.overview?.['max-elv'] },
            { label: "No. of Revisit", value: res?.data[0]?.overview?.['revisits'] },
          ];
          setGroundStationOutputs(NewgroundStationOutputs);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []); 

  
  const DeOrbitingOutputDiv = ({ label, value }) => (
    <div className="reportDataValues">
      <div className="reportDataValuesLabel">{label}</div>
      <div className="reportDataValuesDivNum">{value}</div>
    </div>
  );

  const GroundStationNames = (item) => (
    <div className="reportConfigItem reportConfigSubItem">
      <div className="reportConfigIcon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
        >
          <path
            d="M8.97004 6.00016C8.97004 7.42006 7.81898 8.57111 6.39908 8.57111C4.97918 8.57111 3.82812 7.42006 3.82812 6.00016C3.82812 4.58026 4.97918 3.4292 6.39908 3.4292C7.81898 3.4292 8.97004 4.58026 8.97004 6.00016Z"
            stroke="#F0F0F0"
            strokeWidth="0.5"
          />
          <path
            d="M11.4676 7.4748C10.8089 9.72297 8.74689 11.2695 6.39848 11.2695C3.49161 11.2695 1.12888 8.90676 1.12888 5.99988C1.12888 3.09301 3.49161 0.730279 6.39848 0.730279C8.76121 0.730279 10.8089 2.29111 11.4676 4.53929C11.5106 4.53929 11.5392 4.52497 11.5822 4.52497C10.9235 2.21952 8.81849 0.615723 6.39848 0.615723C3.42001 0.615723 1 3.02141 1 5.99988C1 8.97835 3.42001 11.384 6.38416 11.384C8.78985 11.384 10.9091 9.78025 11.5678 7.4748C11.5392 7.48912 11.4962 7.4748 11.4676 7.4748Z"
            fill="#F0F0F0"
            stroke="#F0F0F0"
            strokeWidth="0.33651"
          />
          <path
            d="M11.7256 7.27447C11.024 7.27447 10.4512 6.70169 10.4512 6.00003C10.4512 5.29837 11.024 4.72559 11.7256 4.72559C12.4273 4.72559 13.0001 5.29837 13.0001 6.00003C13.0001 6.70169 12.4273 7.27447 11.7256 7.27447ZM11.7256 4.8831C11.1099 4.8831 10.6087 5.38429 10.6087 6.00003C10.6087 6.61577 11.1099 7.11696 11.7256 7.11696C12.3414 7.11696 12.8425 6.61577 12.8425 6.00003C12.8569 5.38429 12.3414 4.8831 11.7256 4.8831Z"
            fill="#F0F0F0"
            stroke="#F0F0F0"
            strokeWidth="0.33651"
          />
        </svg>
      </div>
      <div className="reportConfigItemName">{item}</div>
    </div>
  );

  return (
    <div className="reportDiv">
      <div className="reportTitleDiv">
        <div className="reportTitle">Access Analysis</div>
        <div className="reportDate">{moment(new Date).format('DD - MM - HH - YYYY')}</div>
      </div>
      <div className="modalCheckboxDiv reportCheckBoxDiv">
        <input
          type="checkbox"
          name="checkboxName"
          id="checkboxId"
          className="modalCheckbox"
          // checked={checked}
          // onChange={handleChange}
        />
        <button
          className="modalDropDownIconBtn"
          onClick={() =>
            setGroundStationItems({
              Analysis_Inputs: !groundStationItems.Analysis_Inputs,
              Output: groundStationItems.Output,
            })
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d={
                groundStationItems.Analysis_Inputs
                  ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344"
                  : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"
              }
              stroke="#F0F0F0"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="modalCheckboxText modalWhiteSubHeader">
          Analysis Inputs
        </div>
      </div>

      {groundStationItems.Analysis_Inputs && (
        <div className="reportConfigDiv">
          <div className="reportConfigItem">
            <div className="reportConfigIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M9.45137 6.2486C10.2873 6.25003 11.0985 5.96554 11.7502 5.4424C11.8237 5.38408 11.8839 5.31076 11.9268 5.22735C11.9696 5.14394 11.9942 5.05235 11.9989 4.95869C12.0044 4.85944 11.9887 4.76016 11.9528 4.66748C11.9168 4.57479 11.8615 4.49084 11.7905 4.42122L9.92189 2.55353C10.184 2.29152 10.4596 2.01607 10.7218 1.74734C10.7756 1.70031 10.8226 1.65328 10.8764 1.59953C10.9363 1.53587 10.9696 1.45178 10.9696 1.36439C10.9696 1.27701 10.9363 1.19292 10.8764 1.12925C10.8451 1.09777 10.808 1.07278 10.767 1.05572C10.7261 1.03867 10.6821 1.02989 10.6378 1.02989C10.5934 1.02989 10.5495 1.03867 10.5085 1.05572C10.4676 1.07278 10.4304 1.09777 10.3991 1.12925C10.0765 1.44501 9.76729 1.76077 9.44464 2.07653L7.57599 0.208846C7.50542 0.139157 7.42127 0.0847097 7.32876 0.0488828C7.23626 0.0130559 7.13737 -0.00338571 7.03825 0.000578541C6.9447 0.00600657 6.85331 0.0309245 6.76997 0.0737327C6.68662 0.116541 6.61315 0.176294 6.55428 0.249156C5.99599 0.946173 5.71155 1.82295 5.75438 2.71477L4.77972 3.69565L3.21355 2.13028C3.15221 2.06652 3.07862 2.01579 2.99719 1.98113C2.91576 1.94648 2.82816 1.92862 2.73966 1.92862C2.65116 1.92862 2.56357 1.94648 2.48214 1.98113C2.40071 2.01579 2.32712 2.06652 2.26578 2.13028L0.195465 4.19952C0.0702708 4.32539 0 4.49567 0 4.67316C0 4.85065 0.0702708 5.02092 0.195465 5.1468L1.765 6.71216L1.48941 6.9809C1.15693 7.31457 0.970257 7.7663 0.970257 8.23722C0.970257 8.70814 1.15693 9.15987 1.48941 9.49354L2.5044 10.508C2.6689 10.674 2.86468 10.8058 3.08043 10.8957C3.29618 10.9856 3.52762 11.0319 3.76137 11.0319C3.99513 11.0319 4.22657 10.9856 4.44232 10.8957C4.65807 10.8058 4.85385 10.674 5.01835 10.508L5.28722 10.2393L6.8534 11.8046C6.97934 11.9298 7.1497 12 7.32728 12C7.50486 12 7.67523 11.9298 7.80117 11.8046L9.87148 9.72868C9.99667 9.60281 10.0669 9.43253 10.0669 9.25504C10.0669 9.07755 9.99667 8.90728 9.87148 8.7814L8.31202 7.22275L9.28668 6.24188C9.3414 6.24734 9.39639 6.24958 9.45137 6.2486ZM0.66599 4.67652L2.74302 2.60056L4.30248 4.16593L2.23553 6.23516L0.66599 4.67652ZM9.39759 9.2584L7.32728 11.3276L5.76111 9.76227L7.83142 7.69304L9.39759 9.2584ZM5.8821 3.54112C6.05212 4.15693 6.37947 4.71794 6.83201 5.16906C7.28454 5.62019 7.8467 5.94591 8.46326 6.11423L4.53774 10.0377C4.33081 10.2442 4.05038 10.3601 3.75801 10.3601C3.46564 10.3601 3.18521 10.2442 2.97829 10.0377L1.95657 9.01654C1.75003 8.80972 1.63402 8.52944 1.63402 8.23722C1.63402 7.945 1.75003 7.66472 1.95657 7.4579L5.8821 3.54112ZM7.30712 4.68995C6.77863 4.16863 6.46477 3.4683 6.42744 2.72708C6.39011 1.98587 6.63202 1.25758 7.10546 0.685846L9.20938 2.78867L11.32 4.89822L11.3335 4.91838C10.7517 5.38187 10.0194 5.61481 9.27665 5.57267C8.53386 5.53053 7.83267 5.21627 7.30712 4.68995Z"
                  fill="#F0F0F0"
                />
              </svg>
            </div>
            <div className="reportConfigItemName">&lt;Mission_Sat_01&gt;</div>
          </div>
          {groundStationValues.map(GroundStationNames)}
        </div>
      )}

      <div className="reportConfigDiv">
        <div className="modalCheckboxDiv reportCheckBoxDiv">
          <input
            type="checkbox"
            name="checkboxName"
            id="checkboxId"
            className="modalCheckbox"
            // checked={checked}
            // onChange={handleChange}
          />
          <button
            className="modalDropDownIconBtn"
            onClick={() =>
              setGroundStationItems({
                Analysis_Inputs: groundStationItems.Analysis_Inputs,
                Output: !groundStationItems.Output,
              })
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d={
                  groundStationItems.Output
                    ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344"
                    : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"
                }
                stroke="#F0F0F0"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="modalCheckboxText modalWhiteSubHeader">Output</div>
          <button className="reportCommentBtn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M11.6667 1.33325H2.33333C1.97971 1.33325 1.64057 1.47373 1.39052 1.72378C1.14048 1.97382 1 2.31296 1 2.66659V12.6666L3.31133 10.9333C3.54213 10.7602 3.82284 10.6666 4.11133 10.6666H11.6667C12.0203 10.6666 12.3594 10.5261 12.6095 10.2761C12.8595 10.026 13 9.68687 13 9.33325V2.66659C13 2.31296 12.8595 1.97382 12.6095 1.72378C12.3594 1.47373 12.0203 1.33325 11.6667 1.33325Z"
                stroke="#F0F0F0"
                strokeWidth="0.888889"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button className="reportCommentBtn reportTagBtn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M8.61928 11.4458C8.26397 11.8007 7.78234 12 7.28017 12C6.778 12 6.29636 11.8007 5.94106 11.4458L0.679353 6.31667C0.300359 5.96925 0.0161133 5.45128 0.0161133 4.89542V1.895C0.0161133 1.39241 0.215761 0.910414 0.571137 0.555033C0.926513 0.199651 1.40851 0 1.91108 0H4.91145C5.46731 0 5.98527 0.28425 6.33268 0.66325L11.4302 5.95662C11.785 6.31193 11.9843 6.79357 11.9843 7.29575C11.9843 7.79793 11.785 8.27957 11.4302 8.63488L8.61928 11.4458ZM8.1708 10.9973L10.9817 8.1864C11.4744 7.6937 11.4744 6.89148 10.9817 6.39878L5.77051 0.998033C5.56206 0.758 5.25887 0.631667 4.91145 0.631667L1.89213 0.612717C1.19731 0.612717 0.64777 1.20017 0.64777 1.895V4.89542C0.64777 5.24283 0.774102 5.54603 1.01413 5.75448L6.38322 10.9973C6.87591 11.49 7.67811 11.49 8.1708 10.9973ZM2.85857 1.26333C3.27738 1.26333 3.67905 1.42971 3.97519 1.72586C4.27134 2.02201 4.43771 2.42368 4.43771 2.8425C4.43771 3.26132 4.27134 3.66299 3.97519 3.95914C3.67905 4.25529 3.27738 4.42167 2.85857 4.42167C2.43975 4.42167 2.03809 4.25529 1.74195 3.95914C1.4458 3.66299 1.27943 3.26132 1.27943 2.8425C1.27943 2.42368 1.4458 2.02201 1.74195 1.72586C2.03809 1.42971 2.43975 1.26333 2.85857 1.26333ZM2.85857 1.895C2.60728 1.895 2.36628 1.99483 2.1886 2.17252C2.01091 2.35021 1.91108 2.59121 1.91108 2.8425C1.91108 3.09379 2.01091 3.33479 2.1886 3.51248C2.36628 3.69017 2.60728 3.79 2.85857 3.79C3.10986 3.79 3.35086 3.69017 3.52854 3.51248C3.70623 3.33479 3.80606 3.09379 3.80606 2.8425C3.80606 2.59121 3.70623 2.35021 3.52854 2.17252C3.35086 1.99483 3.10986 1.895 2.85857 1.895Z"
                fill="#F0F0F0"
              />
            </svg>
          </button>
        </div>
        {groundStationItems.Output && (
          <>
            <div className="reportConfigHeader white">Overview</div>
            <select
              name="reportOutputTime"
              id="reportOutputTime"
              className="reportConfigDropdown"
            >
              <option value="Per Hour">Per Month</option>
              <option value="Per Week">Per Week</option>
              <option value="Per Month">Per Day</option>
              <option value="Per Day">Per Year</option>
            </select>
            <div className="reportDataValuesDiv">
              {groundStationOutputs.map(DeOrbitingOutputDiv)}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GroundStationAccessReport;
